import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const CATEGORY_LABELS = {
  excavadora: "Excavadora", cargador: "Cargador", camion_minero: "Camión Minero",
  retroexcavadora: "Retroexcavadora", grua: "Grúa", compactadora: "Compactadora", otro: "Equipo",
};

const AVAIL = {
  disponible: { t: "Disponible", c: "bg-green-500/15 text-green-500 border-green-500/30" },
  alquilado: { t: "Alquilado", c: "bg-orange-500/15 text-orange-500 border-orange-500/30" },
  vendido: { t: "Vendido", c: "bg-red-500/15 text-red-500 border-red-500/30" },
  mantenimiento: { t: "Mantenimiento", c: "bg-blue-500/15 text-blue-500 border-blue-500/30" },
};

export function MachineryCard({ m }) {
  const av = AVAIL[m.availability] || AVAIL.disponible;
  return (
    <Link to={`/maquinaria/${m.id}`} data-testid={`machinery-card-${m.id}`}
      className="group block bg-card border border-border hover:border-brand transition-colors">
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img src={m.images?.[0]} alt={m.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className={`absolute top-3 left-3 text-[11px] font-semibold px-2 py-1 border ${av.c}`}>{av.t}</span>
        <span className="absolute top-3 right-3 text-[11px] font-semibold px-2 py-1 bg-black/70 text-white uppercase tracking-wider">
          {m.sector}
        </span>
      </div>
      <div className="p-5">
        <div className="overline text-brand mb-1">{CATEGORY_LABELS[m.category] || "Equipo"} · {m.brand}</div>
        <h3 className="font-display font-bold text-xl tracking-tight leading-none mb-3 group-hover:text-brand transition-colors">
          {m.name}
        </h3>
        <div className="flex items-center gap-1 text-xs text-muted-foreground mb-4">
          <MapPin size={12} /> {m.location?.city}
        </div>
        <div className="flex items-end justify-between border-t border-border pt-3">
          <div>
            {m.price_rent_day != null && (
              <div className="text-sm"><span className="font-display font-black text-brand text-lg">{m.currency} {m.price_rent_day}</span><span className="text-muted-foreground text-xs"> /día</span></div>
            )}
            {m.price_sale != null && (
              <div className="text-xs text-muted-foreground">Venta: {m.currency} {m.price_sale.toLocaleString()}</div>
            )}
          </div>
          <span className="text-xs font-semibold text-foreground group-hover:text-brand transition-colors">Ver más →</span>
        </div>
      </div>
    </Link>
  );
}
